const isExternal = true


const videoPopup = (videoURI, {uri, label}) => [
    {
        width: "56.3%",
        height: "48.3%",
        left: "21.9%",
        isExternal,
        top: "27.1%",
        label: `video-${label}`,
        children: <div style={{height: "100%"}}>
            <iframe src={`${videoURI}&autoplay=1`} width="100%" height="100%" frameBorder="0" allow="autoplay; fullscreen" allowfullscreen/>
        </div>
    },
    {
        width: "28.5%",
        height: "4.7%",
        left: "35.7%",
        isExternal,
        top: "80.3%",
        target: "_blank",
        label: `${label} - popup button`,
        href: uri
    }
]

export const isfServices = [
    ...[
        ["Increasing Resilience Against Cyber Attacks", "https://player.vimeo.com/video/762210652?h=78647ac852"],
        ["Measuring and Managing Information Risk", "https://player.vimeo.com/video/762563993?h=5b3b4d311d"],
        ["Securing the supply chain", "https://player.vimeo.com/video/762211366?h=05a5748d37"],
        ["Ensuring Compliance", "https://player.vimeo.com/video/762564251?h=b567013de4"],
        ["Establishing clear and Actionable Policies", "https://player.vimeo.com/video/762563616?h=f4923e0c24"],
        ["Making people your strongest link", "https://player.vimeo.com/video/762211554?h=7a68191623"],
        ["Optimising brand communication", "https://player.vimeo.com/video/762629731?h=58b291e517"]
    ].map(([label, uri], idx) => {
        return {
            width: "40.3%",
            height: "5.2%",
            left: "30.6%",
            isExternal,
            top: `${27.5 + (idx * 6.3)}%`,
            target: "_blank",
            label,
            href: uri
        }
    }),
    {
        width: "28.7%",
        height: "5.4%",
        left: "36.9%",
        isExternal,
        top: "73%",
        target: "_blank",
        label: "For more, please visit the ISF Library",
        href: "https://www.isflive.org/s/knowledge-library"
    }
]

export const benchmarksLinks = 
    videoPopup("https://player.vimeo.com/video/764621919?h=0639d60a42", {
        uri: "https://benchmark.securityforum.org/Account/Login?ReturnUrl=%2F", 
        label: "Benchmarks"
    })

export const futureResearch = [
    {
        width: "56.3%",
        height: "48.3%",
        left: "21.9%",
        isExternal,
        top: "27.1%",
        label: `video-future-research`,
        children: <div style={{height: "100%"}}>
            <iframe src={`https://player.vimeo.com/video/765096693?h=21cc913f6c&autoplay=1`} width="100%" height="100%" frameBorder="0" allow="autoplay; fullscreen" allowfullscreen/>
        </div>
    },
    {
        width: "25.2%",
        height: "4.7%",
        left: "23.7%",
        isExternal,
        top: "80.3%",
        target: "_blank",
        label: "Create Idea",
        href: "https://www.isflive.org/s/future-research-hub/create-idea"
    },
    {
        width: "25.2%",
        height: "4.7%",
        left: "51%",
        isExternal,
        top: "80.3%",
        target: "_blank",
        label: "Vote for ideas",
        href: "https://www.isflive.org/s/future-research-hub/vote"
    }
]
    
export const qiraLinks = 
    videoPopup("https://player.vimeo.com/video/637435441?h=fce80c465d", {
        uri: "https://www.isflive.org/s/article/Quantitative-Information-Risk-Assessment-QIRA-Methodology-Assistant?topicId=0TO0J0000009AOAWA2", 
        label: "QIRA"
    })

export const iramT = 
    videoPopup("https://player.vimeo.com/video/768578207?h=f869a8bbf7", {
        uri: "https://iram2.securityforum.org/Account/Login?ReturnUrl=%2F",
        label: "iRam2"
    })

export const supplierSec = 
    videoPopup("https://player.vimeo.com/video/768934142?h=119e73d5e7", {
        uri: "https://suppliersecurity.securityforum.org/",
        label: "Supplier Security"
    })

export const SOGP = 
    videoPopup("https://player.vimeo.com/video/768919114?h=526531aa88", {
        uri: "https://sogp.securityforum.org/login",
        label: "SOGP"
    })


export const ThreadHorizon = 
    videoPopup("https://player.vimeo.com/video/766041783?h=3f73ac6dab", {
        uri: "https://www.isflive.org/s/topic/0TO0J0000009AODWA2/threat-horizon", 
        label: "Threat Horizon"
    })

export const magazineRackLeft = [
    ...[
        ["ISF Services Brochure", "https://assets.swoogo.com/uploads/2165172-63600ab42179f.pdf"],
        ["ISF Chapter Programme 2023", "https://assets.swoogo.com/uploads/2165173-63600ab50323c.pdf"],
        ["ISF Member Code of Conduct", "https://assets.swoogo.com/uploads/2165179-63600ab5ad4a7.pdf"],
        ["ISF Constitution", "https://assets.swoogo.com/uploads/2165178-63600ab5ac13d.pdf"],
        ["ISF Future Research Hub", "https://assets.swoogo.com/uploads/2165176-63600ab5ace5d.pdf"],
        ["ISF Membership Benefits", "https://assets.swoogo.com/uploads/2165175-63600ab583784.pdf"],
        ["ISF Membership Referral Reward Programme", "https://assets.swoogo.com/uploads/2165174-63600ab584a04.pdf"],
        ["ISF Learning - Risk Practitioner", "https://assets.swoogo.com/uploads/2165180-63600ab691502.pdf"],
        ["ISF Roles of Primary and Secondary Users", "https://assets.swoogo.com/uploads/2165177-63600ab5accd9.pdf"]
    ].map(([label, href], idx) =>({
        width: "45.5%",
        height: "5.1%",
        left: "27.4%",
        isExternal,
        top: `${20.9 + (idx * 6.3)}%`,
        target: "_blank",
        label,
        href
    })),
    {
        width: "29.6%",
        height: "5.1%",
        left: "35.5%",
        isExternal,
        top: "80%",
        target: "_blank",
        label: "ISF Library",
        href: "https://www.isflive.org/s/knowledge-library"
    }
]

export const magazineRackR = [
    ...[
        ["How will you respond to a ransomware", "https://assets.swoogo.com/uploads/2154630-6358424875721.pdf"],
        ["Do you need to improve your team risk assessment", "https://assets.swoogo.com/uploads/2154631-63584248c1113.pdf"],
        ["Suppliers putting you at risk", "https://assets.swoogo.com/uploads/2154632-6358424ab202a.pdf"],
        ["Measure security controls", "https://assets.swoogo.com/uploads/2154640-6358424bc357a.pdf"],
        ["Security standards ar up-to-date", "https://assets.swoogo.com/uploads/2154634-6358424b475c0.pdf"],
        ["Are people your weakest link or strongest", "https://assets.swoogo.com/uploads/2154637-6358424b8f96a.pdf"],
        ["How forward-looking is your cyber security strategy", "https://assets.swoogo.com/uploads/2154638-6358424bbbea1.pdf"],
        ["Threat intelligence - React and Prepare", "https://assets.swoogo.com/uploads/2154649-6358424ee3826.pdf"],
        ["Managing Cyber in times of instability", "https://assets.swoogo.com/uploads/2154642-6358424c75264.pdf"],
        ["Understainding the Ransomware Menace", "https://assets.swoogo.com/uploads/2154643-6358424d5e372.pdf"],
        ["ICS insights: Organic convergence", "https://assets.swoogo.com/uploads/2154648-6358424e3c021.pdf"],
        ["ICS Insights: Understanding threats to ICS", "https://assets.swoogo.com/uploads/2154647-6358424e65937.pdf"],
        ["ICS Insights: Challenging manufacturers", "https://assets.swoogo.com/uploads/2154645-6358424d80a81.pdf"]
    ].map(([label, href], idx) =>({
        width: "40.1%",
        height: "4.2%",
        left: "30.7%",
        isExternal,
        top: `${17.1 + (idx * 5)}%`,
        target: "_blank",
        label,
        href
    })),
    {
        width: "28.6%",
        height: "5.1%",
        left: "37%",
        isExternal,
        top: "84.5%",
        target: "_blank",
        label: "ISF Library",
        href: "https://www.isflive.org/s/knowledge-library"
    }
]